/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Delete_Document_ErrorInputs */

const en_orders_delete_document_error = /** @type {(inputs: Orders_Delete_Document_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to delete document.`)
};

const es_orders_delete_document_error = /** @type {(inputs: Orders_Delete_Document_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudo eliminar el documento.`)
};

/**
* | output |
* | --- |
* | "Failed to delete document." |
*
* @param {Orders_Delete_Document_ErrorInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_delete_document_error = /** @type {((inputs?: Orders_Delete_Document_ErrorInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Delete_Document_ErrorInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_delete_document_error(inputs)
	return es_orders_delete_document_error(inputs)
});